import { render, staticRenderFns } from "./MultiPots.vue?vue&type=template&id=6a1b9d80&"
import script from "./MultiPots.vue?vue&type=script&lang=js&"
export * from "./MultiPots.vue?vue&type=script&lang=js&"
import style0 from "./MultiPots.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports